import request from '@/utils/request'

/**
 * 获取优惠券列表
 * @param {Object} query - 查询参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function couponlist(query) {
  return request({
    url: '/coupon/coupon/page', // 请求的API端点
    method: 'get', // 请求方法为GET
    params: query, // 将查询参数添加到请求中
  })
}

/**
 * 删除优惠券列表的函数
 * @param {Object} data - 删除优惠券所需的数据
 * @returns {Promise} 返回一个Promise对象，包含请求的结果
 */
export function deletecouponlist(data) {
  return request({
    url: 'coupon/coupon/delete', // 请求的URL地址
    method: 'post', // 请求方法为POST
    data, // 请求数据
  })
}

// 查询优惠券详细
export function getObj(id) {
    return request({
        url: '/coupon/coupon/detail?id=' + id,
        method: 'get',
    })
}
// 新增优惠券
export function addObj(data) {
    return request({
        url: '/coupon/coupon/add',
        method: 'post',
        data: data,
    })
}

// 修改优惠券
export function putObj(data) {
    return request({
        url: '/coupon/coupon/edit',
        method: 'post',
        data: data,
    })
}

/**
 * 取消优惠券发放的函数
 * @param {Object} data - 取消优惠券发放所需的数据
 * @returns {Promise} - 返回一个Promise对象，包含请求的结果
 */
export function cancelCouponLaunch(data) {
  return request({
    url: 'coupon/coupon/cancelPut',
    method: 'post',
    data,
  })
}

export function auditCoupon(data) {
  return request({
    url: '/coupon/coupon/check',
    method: 'post',
    data,
  })
}

export function updatePutonStatus(data) {
  return request({
    url: '/coupon/coupon/illegal',
    method: 'post',
    data,
  })
}

export function updatePutonStatusput(data) {
  return request({
    url: '/coupon/coupon/put',
    method: 'post',
    data,
  })
}

export function distributeCoupon(data) {
  return request({
    url: '/coupon/coupon/send',
    method: 'post',
    data,
  })
}

export function listCode(params) {
  return request({
    url: '/coupon/coupon-activation/page',
    method: 'get',
    params,
  })
}

export function deleteCode(data) {
  return request({
    url: 'coupon/coupon-activation/delete', // 请求的URL地址
    method: 'post', // 请求方法为POST
    data, // 请求数据
  })
}

export function listUserCoupon(params) {
  return request({
    url: '/coupon/coupon-user/page',
    method: 'get',
    params,
  })
}

export function deleteUserCoupon(data) {
  return request({
    url: `/coupon/coupon-user/delete`,
    method: 'post', // 请求方法为POST
    data, // 请求数据
  })
}

export function updateUserCoupon(data) {
  return request({
    url: `/coupon/coupon-user/edit`,
    method: 'post', // 请求方法为POST
    data, // 请求数据
  })
}

export function infoStatUserCoupon(params) {
  return request({
    url: '/coupon/coupon/tj',
    method: 'get',
    params,
  })
}

export function fetchPackageList(params) {
  return request({
    url: '/coupon/coupon/tj',
    method: 'get',
    params,
  })
}

export function getAvailableCoupons(params) {
  return request({
    url: '/coupon/user/tenant/page/self',
    method: 'get',
    params,
  })
}
export function getCouponDetail(params) {
  return request({
    url: '/coupon/coupon/detail',
    method: 'get',
    params,
  })
}

/**
 * 查询单位可用优惠券
 * @param {Object} params - 查询参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function getTenantAvailableCoupons(params) {
  return request({
    url: '/coupon/user/tenant/available',
    method: 'get',
    params,
  })
}

/**
 * 查询优惠券激活码分页（用户视图）
 * @param {Object} params - 查询参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function getCouponActivationList(params) {
  return request({
    url: '/coupon/activation/page',
    method: 'get',
    params,
  })
}

/**
 * 查询优惠券激活码分页（租户视图）
 * @param {Object} params - 查询参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function getCouponActivationTenantList(params) {
  return request({
    url: '/coupon/activation/page/tenant',
    method: 'get',
    params,
  })
}

/**
 * 批量生成激活码
 * @param {Object} data - 生成参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function batchGenerateActivationCodes(data) {
  return request({
    url: '/coupon/activation/add',
    method: 'post',
    data,
  })
}

/**
 * 查询单位持有优惠券分页（发放记录）
 * @param {Object} params - 查询参数对象
 * @returns {Promise} - 返回一个Promise，包含请求的结果
 */
export function getDistributeRecordList(params) {
  return request({
    url: '/coupon/user/tenant/page',
    method: 'get',
    params,
  })
}
